/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.string().uuid(),
  createdAt: z.number(),
  updatedAt: z.number(),
  construction_plan_id: z.string().uuid(),
  area_info_1: z.string(),
  area_info_2: z.string(),
  area_info_3: z.string(),
  area_info_4: z.string(),
  area_info_5: z.string(),
  deleted_at: z.number().nullable(),
  work_id: z.number().nullable(),
  work_type_id: z.number().nullable(),
  work_subtype_id: z.number().nullable(),
  planned_qty: z.number().nullable(),
  planned_start: z.number().nullable(),
  planned_end: z.number().nullable(),
  remarks: z.string().nullable(),
  created_by_user_id: z.string().uuid().nullable(),
});
const create = base.extend({
  work_id: base.shape.work_id.optional(),
  work_type_id: base.shape.work_type_id.optional(),
  work_subtype_id: base.shape.work_subtype_id.optional(),
  planned_qty: base.shape.planned_qty.optional(),
  planned_start: base.shape.planned_start.optional(),
  planned_end: base.shape.planned_end.optional(),
  remarks: base.shape.remarks.optional(),
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
  created_by_user_id: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
  created_by_user_id: true,
})
.extend({ id: z.string().uuid() });
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const ConstructionPlanAreaBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type ConstructionPlanAreaBase = z.infer<typeof base>;
export type ConstructionPlanAreaBasePutPayload = z.infer<typeof put>;
export type ConstructionPlanAreaBasePatchPayload = z.infer<typeof patch>;
export type ConstructionPlanAreaBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type ConstructionPlanAreaBaseCreateAttributes = z.infer<typeof create>;
export type ConstructionPlanAreaBaseUpdateAttributes = z.infer<typeof update>;
export type ConstructionPlanAreaBaseCacheAttributes = z.infer<typeof cache>;
export type ConstructionPlanAreaBaseCachesAttributes = z.infer<typeof caches>;